import ForgottenPasswordForm from '../components/organism/forms/ForgottenPasswordForm'

const Password = () => <ForgottenPasswordForm />

export default Password
